export const getPathName = (url) => url.replace(/https?:\/\/[^/]+|\?.+$/g, '');
